// When the desktop sidebar starts folded (1.39, 2026-10-12).
//
// Nodari's till is a Posiflex 15" touch screen, 4:3, 1024×768 native. With the
// menu open, the till's product tiles were 71 px wide with their names cut, and
// the search box was 155 px. The owner called it „გაბერილი და გაწელილი".
// Folded, the tiles are 109 px. At 1280 px (the 5:4 17" tills, a laptop at
// Windows' 150 %) the tiles go from 106 to ~136 px.
//
// Below 1366 px the menu starts folded. The ≡ button then opens it OVER the
// page for a moment (the till does not reflow under it). A tap outside, Esc or
// a new page folds it again, and nothing is remembered. From 1366 px up, ≡ is
// the device's own remembered choice, as before (`isDesktopSidebarCollapsed`).
// Phones (< 768 px) have no sidebar, only the tab capsule.

const PHONE_BELOW = 768
const FOLD_BELOW = 1366

/** Whether a desktop window this wide starts with the menu folded. */
export function foldsSidebar(width: number): boolean {
  return width >= PHONE_BELOW && width < FOLD_BELOW
}

/** `foldsSidebar` as a media query, for `useMediaQuery`. */
export const SIDEBAR_FOLD_QUERY = `(min-width: ${PHONE_BELOW}px) and (max-width: ${FOLD_BELOW - 0.02}px)`

/** The menu's state on screen. `saved` is the wide screens' remembered ≡
 *  choice; `peek` is a narrow screen's „open it for a moment". */
export function sidebarFolded(o: { narrow: boolean; saved: boolean; peek: boolean }): boolean {
  return o.narrow ? !o.peek : o.saved
}
